export enum QUERY_KEYS {
  changeUser = 'change-user',
  getAuthContext = 'get-auth-context',
  getUserRoles = 'get-user-roles',
  signin = 'signin',
  signout = 'signout',
}
